import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { confirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import { SplitButton } from "primereact/splitbutton";
import { Dialog } from "primereact/dialog";
import { Checkbox } from "primereact/checkbox";
import { TabView, TabPanel } from "primereact/tabview";

// ------------------ COMPONENTES DE BASE--------------------------
import { AuthContext } from "../../../../../Base/Context/AuthContext/AuthContext";
import Card from "../../../../../Base/Components/Card/Card";
import { toastShow } from "../../../../../Base/Services/ToastService";
import { getLabel } from "../../../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../../../Base/Lang/BaseLang";
import { ConfigContext } from "../../../../../Base/Context/ConfigContext/ConfigContext";
import { getDatesProduccion } from "../../../../../Base/Services/Moment/Luxon";
import { setTitlePage } from "../../../../../Base/Services/Config/ConfigService";
import CalendarioOperativo from "../../../../../Base/Components/Form/CalendarioOperativo";
import AgGrid from "../../../../../Base/Components/Tables/AgGrid/AgGrid";

// ------------------- CONSULTAS A LA API---------------------------
import { ObtenerIngresosEncabezado } from "../../../../../API/Suministros/IngresosBodega/IngresosBodegaEncabezadoRequest";
import {
  EliminarSalidasMateriales,
  SalidasMDetalles,
  SalidasMP,
  obtenerDetalleSalidaPacas,
} from "../../../../../API/Suministros/SalidasMateriales/SalidasMaterialesRequest";
import { ObtenerRequisasMaterialesDet } from "../../../../../API/Suministros/IngresosMateriales/IngresosMaterialesRequest";

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import ReporteSalidaMP from "./Reporte/ReporteSalidaMP";
import SalidasMaterialesCrud from "./SalidasMaterialesCrud/SalidasMaterialesCrud";
import IngresosBodegaCrud from "../IngresosBodega/IngresosCRUD/IngresosBodegaCrud";
import ListadoSalidasMaterialesEnc from "./SalidasMaterialesCrud/ListadoRequisasMateriales";


const SalidasMaterialesScreen = ({MateriaPrima = null}) => {

  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);

  const [listadoEnc, setListadoEnc] = useState([]);
  const [listadoDet, setListadoDet] = useState([]);
  const [requisaM, setRequisaM] = useState([]);
  const [dates, setDates] = useState([new Date(), new Date()]);
  const [showDialogRequisasM, setShowDialogRequisasM] = useState(false);
  const [showDialogSalida, setShowDialogSalida] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState([]);  
  const [ingresoToShow, setIngresoToShow] = useState(null);
  const [habilitar, setHabilitar] = useState(true);
  const [showDialogI, setShowDialogI] = useState(false);
  // El acceso 38 permite VER los costos de las salidas: se ocultan a quien no lo tiene
  const [hiddenCostosSalidas, setHiddenCostosSalidad] = useState(userAuth.AccessWeb.split(",").map((e) => parseInt(e)).includes(38));

  const [listadoSalidaPacas, setListadoSalidaPacas] = useState([]);
  const [selectedSalidaPacas, setSelectedSalidaPacas] = useState([]);
  const [salidaReporte, setSalidaReporte] = useState(null);

  const [showReporteSalidaMP, setShowReporteSalidaMP] = useState(false);
  const [languageReporte, setLanguageReporte] = useState("es");
  const [activeIndex, setActiveIndex] = useState(0);

  const getInfo = async () => {

    if (!dates || dates.length !== 2 || !dates[0] || !dates[1]) {
      toastShow( toast, "warn", "Advertencia", "Por favor, seleccione un rango de fechas válido.");
      return;
    }
    setLoading(true);

    const fechas = getDatesProduccion(dates);
    const enc = await ObtenerIngresosEncabezado(fechas);
    setListadoEnc(enc);
    const RequisasMat = await ObtenerRequisasMaterialesDet();
    setRequisaM(RequisasMat)

    const det = await SalidasMDetalles(fechas);
    let data 

    if (MateriaPrima) {
      const det2 = await SalidasMP(fechas);

      data = det2?.filter(
        (i) => i.IsMateriaPrima === true
      );

      // DETALLE DE PACAS QUE YA FUERON DESPACHADAS
      const detallePacas = await obtenerDetalleSalidaPacas(fechas);

      setListadoSalidaPacas(
        detallePacas || []
      );

    } else {

      data = det?.filter(
        (i) => i.IsMateriaPrima !== true
      );

      setListadoSalidaPacas([]);
    }

    setListadoDet(data)
    setSelected([])
    setLoading(false);
  };

  const eliminarSalida = async () => {
    if(selected.length === 0){
      toastShow( toast, "warn", "Advertencia", "Seleccione una salida de Material a Eliminar.");
      return;
    }else{
      selected.forEach(async (select) => {
        if (selected.length > 0) {
          const a = {
            IdSalidaDetalle: select?.IdSalidaDetalle,
            IdRequisaDet: select?.IdRequisaDetalle,
            IdProduct: select?.IdProducto,
            CantidadADespachar: select?.QtySalida,
            IdUsuarioDespacho: select?.IdUsuarioDespacho
          }

          const response = await EliminarSalidasMateriales(a)
          if (response[0].ESTADO !== -1) {
            toastShow(toast,"success","Eliminado",response[0].MENSAJE);
            getInfo()
          } else {
            toastShow(toast,"error","Error",response[0].MENSAJE);
          }

        } 
      })
    }
  };

  const columns = [
    {
      field: "IdSalidaDetalle",
      header: "ID",
      headerEn: "ID",
      className: "XXsmall",
      frozen: "frozen",
      hidden: userAuth.IdRol === 1,
      onCellDoubleClicked: ({ data }) => {
        setShowDialogSalida(true);
        setSelected(data);
      },
    },
    {
      field: "FechaSalida",
      header: "Fecha de Salida",
      headerEn: "Departure Date",
      className: "medium",
      body: (rowData) => rowData.FechaDet,
      frozen: "frozen",
      Format: "DateTime2",
      
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "StatusName",
      frozen: true,
      className: "small",
      Format: "Estado",
      body: (rowData) => ({ ID: rowData.IdEstado, Estado: rowData.StatusName }),
      
    },
    {
      field: "Requisa",
      headerEn: "No. Material Requisition",
      header: "No. Requisa Material",
      className: "small",
      body: (rowData) => rowData.Requisa,
      Sumary: "count",
      frozen: "frozen",
      Format: "Modal",
      onCellDoubleClicked: ({ data }) => {
        setShowDialogSalida(true);
        setSelected(data);
      },
    },
    {
      field: "NumeroIngreso",
      headerEn: "Entry Number",
      header: "No. Ingreso",
      className: "small",
      body: (rowData) => rowData.NumeroIngreso,
      Format: "Modal",
      align: "center",
      onCellDoubleClicked: ({ data }) => {
        Ingreso(data.NumeroIngreso);
      },
    },
    {
      field: "CodigoProducto",
      header: "Codigo Producto",
      headerEn: "Product Code",
      className: "Xsmall",
    },
    {
      field: "NombreProducto",
      header: "Nombre Producto",
      headerEn: "Product Name",
      className: "Xlarge",
    },
    {
      field: "Comentario",
      header: "Comentario",
      headerEn: "Comment",
      className: "Xlarge",
    },
    {
      field: "UnitName",
      header: "Unidad",
      headerEn: "Unit",
      className: "Xsmall",
    },
    {
      field: "NombreCategoria",
      header: "Tipo Producto",
      headerEn: "Product Type",
      className: "small",
    },
    {
      field: "NombreSubcategoria",
      header: "Categoría",
      headerEn: "Category",
      className: "small",
    },
    {
      field: "Area",
      header: "Area",
      headerEn: "Area",
      className: "medium",
    },
    {
      field: "ComentarioRequisa",
      header: "Comentario Requisa",
      headerEn: "Comment Requisition",
      className: "medium",
    },
    {
      field: "UserNameDespacho",
      header: "Usuario Despacho",
      headerEn: "Usuario Despacho",
      className: "small",
    },
    {
      header: "Usuario Autorizó",
      headerEn: "User Auth",
      field: "UserNameAutorizoSolicita",
      className: "small",
    },
    {
      header: "Persona Recibio",
      headerEn: "Person Received",
      field: "NombreRecibe",
      className: "small",
    },
    {
      // Materia prima: precio por kg del lote guardado en la salida
      field: MateriaPrima ? "PrecioSalidaL" : "PrecioL",
      header: MateriaPrima ? "Precio Kg L" : "Precio L",
      Sumary: "sum",
      headerEn: MateriaPrima ? "Price Kg L" : "Price L",
      className: "Xsmall",
      Format: "Currency",
      hidden: hiddenCostosSalidas,
    },
    {
      field: MateriaPrima ? "PrecioSalidaD" : "PrecioD",
      header: MateriaPrima ? "Precio Kg D" : "Precio D",
      Sumary: "sum",
      headerEn: MateriaPrima ? "Price Kg D" : "Price D",
      className: "Xsmall",    
      Format: "Currency",
      hidden: hiddenCostosSalidas,
    },
    {
      field: "MontoL",
      header: "Monto L",
      Sumary: "sum",
      headerEn: "Monto L",
      className: "Xsmall",
      Format: "Currency",
      hidden: hiddenCostosSalidas,
    },
    {
      field: "MontoD",
      header: "Monto D",
      headerEn: "Monto D",
      Sumary: "sum",
      className: "Xsmall", 
      Format: "Currency",
      hidden: hiddenCostosSalidas,
    },
    {
      field: "Revisado",
      header: "Revisado Fin",
      className: "Xsmall",
      Format: "Template",
      frozen: "true",
      alignFrozen: "right",
      filter: false,
      body: (rowData) => (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
          <Checkbox checked={rowData.Revisado === 1 ? true : false} />
        </div>
      ),
    },
    // Materia prima: columnas sin congelar para que la tabla no quede angosta en medio
    ...(MateriaPrima
    ? [
        // PESO NETO TOTAL DEL INGRESO
        {
          header: "Ingreso Neto Kg",
          headerEn: "Net Weight In Kg",
          field: "IngresoPesoNetoKg",
          Sumary: "sum",
          className: "Xsmall",
          Format: "Currency",
        },
        {
          header: "Ingreso Neto Lbs",
          headerEn: "Net Weight In Lbs",
          field: "IngresoPesoNetoLbs",
          Sumary: "sum",
          className: "Xsmall",
          Format: "Currency",
        },

        // CANTIDAD TOTAL DE PACAS DEL INGRESO
        {
          header: "Ingreso Pacas",
          headerEn: "Bales In",
          field: "IngresoPacas",
          Sumary: "sum",
          className: "small",
          Format: "Right",
        },

        // PACAS SOLICITADAS EN LA REQUISA
        {
          header: "Solicitado Pacas",
          headerEn: "Requested Bales",
          field: "SolicitadoPacas",
          Sumary: "sum",
          className: "small",
          Format: "Right",
        },

        // PESO NETO DE ESTA SALIDA
        {
          header: "Despachado Kg",
          headerEn: "Dispatched Kg",
          field: "QtySalida",
          Sumary: "sum",
          className: "small",
          Format: "Currency",
        },
        {
          header: "Despachado Lbs",
          headerEn: "Dispatched Lbs",
          field: "QtySalidaLbs",
          Sumary: "sum",
          className: "small",
          Format: "Currency",
        },

        // CANTIDAD DE PACAS DE ESTA SALIDA
        {
          header: "Despachado Pacas",
          headerEn: "Dispatched Bales",
          field: "QtySalidaPacas",
          Sumary: "sum",
          className: "small",
          Format: "Right",
        },

        // PESO QUE TODAVÍA QUEDA EN ESE INGRESO
        {
          header: "Balance Kg",
          headerEn: "Balance Kg",
          field: "BalancePesoNetoKg",
          Sumary: "sum",
          className: "small",
          Format: "Currency",
        },
        {
          header: "Balance Lbs",
          headerEn: "Balance Lbs",
          field: "BalancePesoNetoLbs",
          Sumary: "sum",
          className: "small",
          Format: "Currency",
        },

        // PACAS QUE TODAVÍA FALTAN POR DESPACHAR DE LA REQUISA
        {
          header: "Balance Pacas",
          headerEn: "Bales Balance",
          field: "BalancePacas",
          Sumary: "sum",
          className: "small",
          Format: "Currency",
          body: (rowData) => rowData?.BalancePacas ?? 0,
        },
      ]
    : [
        // FLUJO NORMAL DE MATERIALES
        {
          header: "Inventario",
          headerEn: "Amount",
          field: "Inventario",
          Sumary: "sum",
          className: "Xsmall",
          Format: "Currency",
          frozen: true,
          alignFrozen: "right",
        },
        {
          header: "Solicitado",
          headerEn: "Amount",
          field: "Qty",
          Sumary: "sum",
          className: "Xsmall",
          Format: "Currency",
          frozen: true,
          alignFrozen: "right",
        },
        {
          header: "Despachado",
          headerEn: "Amount",
          field: "QtySalida",
          Sumary: "sum",
          className: "Xsmall",
          Format: "Currency",
          frozen: true,
          alignFrozen: "right",
        },
        {
          header: "Balance",
          headerEn: "Balance",
          field: "BalanceSalida",
          Sumary: "sum",
          className: "Xsmall",
          Format: "Currency",
          frozen: true,
          alignFrozen: "right",
        },
      ]),

  ];

  const columnsSalidaPacas = [
    {
      field: "IdSalida",
      header: "ID",
      headerEn: "ID",
      className: "XXsmall",
      width: 70,
      minWidth: 70,
      hidden: userAuth.IdRol === 1,
    },
    {
      field: "IdPaca",
      header: "Id Paca",
      headerEn: "Bale ID",
      className: "Xsmall",
      width: 100,
      minWidth: 100,
    },
    {
      field: "FechaSalida",
      header: "Fecha Salida",
      headerEn: "Departure Date",
      className: "medium",
      width: 180,
      minWidth: 180,
      Format: "DateTime2",
    },
    {
      field: "StatusName",
      header: "Estado",
      headerEn: "Status",
      className: "medium",
      width: 140,
      minWidth: 140,
      Format: "Estado",
      body: (rowData) => ({
        ID: rowData?.IdEstado,
        Estado: rowData?.StatusName,
      }),
    },
    {
      field: "Requisa",
      header: "No. Requisa",
      headerEn: "Requisition",
      className: "medium",
      width: 180,
      minWidth: 180,
      Format: "Modal",
      onCellDoubleClicked: ({ data }) => {
        setShowDialogSalida(true);
        setSelected(data);
      },
    },
    {
      field: "NumeroIngreso",
      header: "No. Ingreso",
      headerEn: "Entry Number",
      className: "medium",
      width: 150,
      minWidth: 150,
      Format: "Modal",
      onCellDoubleClicked: ({ data }) => {
        if (data?.NumeroIngreso) {
          Ingreso(data.NumeroIngreso);
        }
      },
    },
    {
      field: "GinBale",
      header: "Gin Bale",
      headerEn: "Gin Bale",
      className: "medium",
      width: 145,
      minWidth: 145,
    },
    {
      field: "CodigoProducto",
      header: "Código Producto",
      headerEn: "Product Code",
      className: "medium",
      width: 160,
      minWidth: 160,
    },
    {
      field: "NombreProducto",
      header: "Producto",
      headerEn: "Product",
      className: "large",
      width: 200,
      minWidth: 200,
    },
    {
      field: "PesoNetoKg",
      header: "Peso Neto Kg",
      headerEn: "Net Weight Kg",
      className: "medium",
      width: 145,
      minWidth: 145,
      Format: "Currency",
      Sumary: "sum",
    },
    {
      field: "PesoNetoLbs",
      header: "Peso Neto Lbs",
      headerEn: "Net Weight Lbs",
      className: "medium",
      width: 145,
      minWidth: 145,
      Format: "Currency",
      Sumary: "sum",
    },
    {
      field: "PrecioL",
      header: "Precio Kg L",
      headerEn: "Price Kg L",
      className: "small",
      width: 130,
      minWidth: 130,
      Format: "Currency",
      hidden: hiddenCostosSalidas,
    },
    {
      field: "MontoL",
      header: "Monto L",
      headerEn: "Amount L",
      className: "small",
      width: 140,
      minWidth: 140,
      Format: "Currency",
      Sumary: "sum",
      hidden: hiddenCostosSalidas,
    },
    {
      field: "PrecioD",
      header: "Precio Kg $",
      headerEn: "Price Kg $",
      className: "small",
      width: 130,
      minWidth: 130,
      Format: "Currency",
      hidden: hiddenCostosSalidas,
    },
    {
      field: "MontoD",
      header: "Monto $",
      headerEn: "Amount $",
      className: "small",
      width: 140,
      minWidth: 140,
      Format: "Currency",
      Sumary: "sum",
      hidden: hiddenCostosSalidas,
    },
    {
      field: "UserNameDespacho",
      header: "Usuario Despachó",
      headerEn: "Dispatched By",
      className: "medium",
      width: 170,
      minWidth: 170,
    },
  ];

  const table = {
    Columns: columns,
    Data: listadoDet,
    loading: loading,
    selected: selected,
    setSelected: (e) => setSelected(e),
    showModal: (e) => showModal(e),
  };

  const tableSalidaPacas = {
    Columns: columnsSalidaPacas,
    Data: listadoSalidaPacas,
    loading: loading,

    selected: selectedSalidaPacas,
    setSelected: (e) => setSelectedSalidaPacas(e),

    showModal: (e) => showModal(e),
  };

  const showModal = (tipoModal) => {
    if (tipoModal === 'ingreso') {
      setShowDialogI(true); 
    } 
  };

  const Ingreso = (Id) => {
    setIngresoToShow(Id);
    setShowDialogI(true);
  };

  const Salida = (Id) => {
    setShowDialogSalida(Id);
    setShowDialogI(true);
  };

  const abrirReporteSalidaMP = (idioma = "es") => {
    if (!selectedSalidaPacas || selectedSalidaPacas.length === 0) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "Seleccione una paca de la salida que desea imprimir."
      );
      return;
    }

    if (selectedSalidaPacas.length > 1) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "Seleccione solamente una paca para identificar la salida."
      );
      return;
    }

    const detallePaca = selectedSalidaPacas[0];
    // Buscamos la salida completa correspondiente
    const salidaCompleta = listadoDet.find((salida) => Number(salida?.IdSalidaDetalle) === Number(detallePaca?.IdSalidaDetalle));
    if (!salidaCompleta) {
      toastShow(
        toast,
        "error",
        "Error",
        "No se encontró la información completa de la salida."
      );
      return;
    }

    setLanguageReporte(idioma);
    setSalidaReporte(salidaCompleta);
    setShowReporteSalidaMP(true);
  };

  const itemsReporteSalidaMP = [
    {
      label: "Español",
      icon: "pi pi-file-pdf",
      command: () => {
        abrirReporteSalidaMP("es");
      },
    },
    {
      label: "Inglés",
      icon: "pi pi-file-pdf",
      command: () => {
        abrirReporteSalidaMP("en");
      },
    },
  ];
  
  const cerrarConfirmacionI = () => {
    if (habilitar && ingresoToShow !== null) {
      confirmDialog({
        message: "¿Estás seguro de cerrar sin guardar los cambios?",
        header: "Cerrar sin guardar",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sí",
        accept: () => {
          setShowDialogI(null);
          setIngresoToShow(null); // Cerrar el diálogo
        },
        rejectLabel: "No",
        reject: () => {}, // No hacer nada si el usuario cancela
        style: { backgroundColor: "white" },
      });
    } else {
      setShowDialogI(null);
      setIngresoToShow(null);
      setHabilitar(true);
    }
  };

  const cerrarConfirmacionS = () => {
    if (habilitar && ingresoToShow !== null) {
      confirmDialog({
        message: "¿Estás seguro de cerrar sin guardar los cambios?",
        header: "Cerrar sin guardar",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sí",
        accept: () => {
          setShowDialogSalida(null);
          setIngresoToShow(null); // Cerrar el diálogo
        },
        rejectLabel: "No",
        reject: () => {}, // No hacer nada si el usuario cancela
        style: { backgroundColor: "white" },
      });
    } else {
      setShowDialogSalida(null);
      setIngresoToShow(null);
      setHabilitar(true);
    }
  };
  
  const ConfirmEliminar = () => {
    if(selected.length === 0){
      toastShow( toast, "warn", "Advertencia", "Seleccione una salida de Material a Eliminar.");
    }else{
      let encuentra = selected.find(i => i?.IdEstadoFinanzas === 112)
      if(encuentra){
        toastShow( toast, "error", "Error", "Una de las salidas seleccionadas ya esta revisada por finanzas, no es posible eliminarla.");
      }else{
        confirmDialog({
          message: "¿Esta seguro de eliminar la salida?",
          header: "Eliminar Salida",
          icon: "pi pi-exclamation-triangle",
          acceptLabel: "Si",
          accept: () => eliminarSalida(),
          rejectLabel: "No",
          style: { backgroundColor: "white" },
        });
      }
    }
  };

  useEffect(() => {
    setTitlePage(getLabel(baseLang, MateriaPrima === 1 ? 'SalidasMP' : "salidasMateriales", config.language));
  }, []);

  return (
    <div>
      <Toast ref={toast} />
      <Card
        titulo={
          <div className="botones flex-wrap">
            <h3>{getLabel(baseLang, MateriaPrima === 1 ? 'SalidasMP' : "salidasMateriales", config.language)}</h3>

            <CalendarioOperativo
              dates={dates}
              setDates={setDates}
              loading={loading}
              getInfo={getInfo}
            />

            <Button
              icon="pi pi-refresh"
              tooltip="Buscar"
              onClick={() => getInfo()}
            />
            <Button
              icon="pi pi-plus"
              tooltip="Nueva"
              onClick={(e) => setShowDialogRequisasM(true)}
            />
            {MateriaPrima && activeIndex === 0 && (
              <SplitButton
                icon="pi pi-print"
                model={itemsReporteSalidaMP}
                tooltip="Imprimir Salida MP"
                onClick={() => abrirReporteSalidaMP("es")}
              />
            )}
            {(!MateriaPrima || activeIndex === 1) && (
              <Button
                icon="pi pi-times"
                className="p-button-danger listado__botones"
                tooltip="Eliminar"
                onClick={() => ConfirmEliminar()}
              />
            )}
          </div>
        }
        contenido={
          MateriaPrima ? (
            <div className="pt-4">
              <TabView
                activeIndex={activeIndex}
                onTabChange={(e) => setActiveIndex(e.index)}
              >
                <TabPanel header="Detalle Salida Pacas">
                  <div style={{ height: "82vh" }}>
                    <AgGrid table={tableSalidaPacas} />
                  </div>
                </TabPanel>

                <TabPanel header="Salidas MP">
                  <div style={{ height: "82vh" }}>
                    <AgGrid table={table} />
                  </div>
                </TabPanel>
              </TabView>
            </div>
          ) : (
            <div className="pt-4">
              <div style={{ height: "82vh" }}>
                <AgGrid table={table} />
              </div>
            </div>
          )
        }
      />

      <Dialog
        visible={showDialogSalida}
        onHide={() => cerrarConfirmacionS()}
        maximized={true}
        maximizable={true}
        closeOnEscape={false}
      >
        <SalidasMaterialesCrud 
          idIngreso={ingresoToShow}
          setIngresoToShow={setIngresoToShow}
          requisa={selected}
          actualizarScreen={getInfo}
          showDialog={showDialogSalida}
          habilitar={habilitar}
          setHabilitar={setHabilitar}
        />
      </Dialog>

      <Dialog
        visible={showDialogRequisasM}
        onHide={() => setShowDialogRequisasM(false)}
        style={{ height: "90vh", width: "1600px" }}
      >
        <ListadoSalidasMaterialesEnc actualizarScreen={getInfo} MateriaPrima={MateriaPrima}/>
      </Dialog>


      <Dialog
        visible={showDialogI}
        onHide={() => {
          cerrarConfirmacionI();
        }}
        maximized={true}
        maximizable={true}
        closeOnEscape={false}
      >
        <IngresosBodegaCrud
          idIngreso={ingresoToShow}
          setIngresoToShow={setIngresoToShow}
          showDialog={showDialogI}
          habilitar={habilitar}
          setHabilitar={setHabilitar}
          editable={false}
        />
      </Dialog>

      {showReporteSalidaMP && salidaReporte && (
        <ReporteSalidaMP
          showReporte={showReporteSalidaMP}
          setShowReporte={setShowReporteSalidaMP}
          salida={salidaReporte}
          Language={languageReporte}
        />
      )}
    </div>
  );
};

export default SalidasMaterialesScreen;